import { LogOut, User } from 'lucide-react';
import { useAuthStore } from '../store/auth';
import { authApi } from '../services/api';

export default function Navbar() {
  const { user, logout } = useAuthStore();

  const handleLogout = async () => {
    await authApi.logout();
    logout();
  };

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-2">
        <img src="/logo-dtfcr.png" alt="DTFCR" className="w-6 h-6 rounded hidden sm:block" onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }} />
        <span className="font-semibold text-gray-800 text-sm hidden sm:block">DTF Costa Rica</span>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <div className="flex items-center gap-2 text-sm">
          <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
            <User size={16} className="text-blue-600" />
          </div>
          <div className="hidden sm:block">
            <p className="font-medium text-gray-800 leading-none">{user?.name}</p>
            <p className="text-xs text-gray-500 mt-0.5 capitalize">{user?.role || ''}</p>
          </div>
        </div>
        <div className="w-px h-6 bg-gray-200 hidden sm:block" />
        <button
          onClick={handleLogout}
          className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 px-2 py-1.5 rounded-lg hover:bg-gray-100"
          title="Cerrar sesión"
        >
          <LogOut size={16} />
          <span className="hidden sm:block">Salir</span>
        </button>
      </div>
    </div>
  );
}
